import RoutemParticleHandler from "../parts/RoutemParticleHandler";
const routemParticleHandler = new RoutemParticleHandler();

window.addEventListener("DOMContentLoaded", () => {
  routemParticleHandler.logScreenViewedEvent();
});
